import { render, staticRenderFns } from "./ReferralProgramProgramsExtra.vue?vue&type=template&id=c667768e&scoped=true&"
import script from "./ReferralProgramProgramsExtra.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramProgramsExtra.vue?vue&type=script&lang=js&"
import style0 from "./ReferralProgramProgramsExtra.vue?vue&type=style&index=0&id=c667768e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c667768e",
  null
  
)

export default component.exports